import {
    postData, 
    getDataWithParams,
    destroyData,
} from '@/store/api/method-mbkm'

const requestInit = {
    page: 1,
    show: 10,
    sortBy: null,
    sorting: null,
    search: null,
}
const itemInit = {
    id: null,
    name: null,
    study_program_id: null,
    type: null,
    weight: null,
    status: null,
}

const initialState = () => ({
    msg: null,
    status: 0,
    data: {},
    // listOprecOpen: [],
    request: {...requestInit},
    item: {...itemInit},
    
})
const state = initialState
 
const getters = {
    getMsg: state => state.msg,
    getStatus: state => state.status,
    getData: state => state.data || {},
    getRequest: state => state.request,
    getItem: state => state.item,
}

const actions = {
    resetRequest({commit}){
        commit('SET_REQUEST',{...requestInit})
    },
    resetItem({commit}){
        commit('SET_ITEM',{...itemInit})
    },
    setItem({commit}, value){
        commit('SET_ITEM',{...value})
    },
    async store({commit}, data) {
        try {
            const payload = {...data}
            delete payload.id
            const response = await postData('/assistantrubricfield',payload);
            commit('SET_RESPONSE', response.data);
        } catch (err) {
            if(err.response){
                commit('SET_FAILED_MESSAGE', err.response);
            }else{
                commit('SET_FAILED')
            }
        }
    },
    async fetchData({commit, state}){
        try {
            const response = await getDataWithParams('/assistantrubricfield',state.request);
            commit('SET_RESPONSE', response.data);
            commit('SET_DATA', response.data.data);
        } catch (err) {
            if(err.response){
                commit('SET_FAILED_MESSAGE', err.response);
            }else{
                commit('SET_FAILED')
            }
        }
    },
    async update({commit}, data) {
        try {
            const url = `/assistantrubricfield/update/${data.id}`
            const payload = {
                ...data
            }
            delete payload.id
            const response = await postData(url,payload);
            commit('SET_RESPONSE', response.data);
        } catch (err) {
            if(err.response){
                commit('SET_FAILED_MESSAGE', err.response);
            }else{
                commit('SET_FAILED')
            }
        }
    },
    async destroy({commit}, data) {
        try {
            const url = `/assistantrubricfield/${data.id}`
            const response = await destroyData(url);
            commit('SET_RESPONSE', response.data);
        } catch (err) {
            if(err.response){
                commit('SET_FAILED_MESSAGE', err.response);
            }else{
                commit('SET_FAILED')
            }
        }
    },
    async updateStatus({commit}, data) {
        try {
            const url = `/assistantrubricfield/update-status/${data.id}`
            const payload = {
                ...data
            }
            delete payload.id
            const response = await postData(url,payload);
            commit('SET_RESPONSE', response.data);
        } catch (err) {
            if(err.response){
                commit('SET_FAILED_MESSAGE', err.response);
            }else{
                commit('SET_FAILED')
            }
        }
    },

    // async fetchValueRange({commit}){
    //     try {
    //         const response = await getAllData('/oprecassistant/list-value-range');
    //         commit('SET_RESPONSE', response.data);
    //         commit('SET_LIST_VALUE_RANGE', response.data.data);
    //     } catch (err) {
    //         if(err.response){
    //             commit('SET_FAILED_MESSAGE', err.response);
    //         }else{
    //             commit('SET_FAILED')
    //         }
    //     }
    // },
    resetState({commit}){
        commit('resetState')
    }
}

const mutations = {
    SET_FAILED(state) {
        state.msg = 'Jaringan Bermasalah'
        state.status = 0
    },
    SET_FAILED_MESSAGE(state, error) {
        state.msg = error?.data?.msg || 'Jaringan Bermasalah'
        state.status = error?.data?.status || 0
    },
    SET_RESPONSE(state, response) {
        state.msg = response.msg
        state.status = response.status
    },
    SET_DATA(state, value) {
        state.data = value
    },
    SET_REQUEST(state, value){
        state.request = value
    },
    SET_ITEM(state, value){
        state.item = value
    },
    SET_LIST_VALUE_RANGE(state, value){
        state.listValueRange = value
    },
    resetState (state) {
        const initial = initialState()
        Object.keys(initial).forEach(key => { state[key] = initial[key] })
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
